<template>
  <v-row>
    <v-col>
      <template v-for="(item, i) in items">
        <div :key="i" class="menu-expandable mb-5">
          <div class="px-0 tcdc-panel-header cursor-pointer" @click="() => onClick(item)">
            <span class="text-uppercase tcdc-menu-title menu-highlight bold">
              {{
              item.name
              }}
            </span>
          </div>
          <div>
            <template v-for="(item, index) of item.subMenuList">
              <div
                :key="index"
                class="text-capitalize tcdc-menu-content"
                style="padding-left: 15px;"
                @click="() => onClickSubMenu(item)"
              > {{ item.name }}</div>
            </template>
          </div>
        </div>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    }
  },
  methods: {
    onClick(item) {
      this.$emit("onClick", item);
    },
    onClickSubMenu(item) {
      this.$emit("onClickSubMenu", item);
    }
  }
};
</script>

<style>
.menu-expandable-bg {
  background-color: black !important;
}
</style>
